export default __webpack_public_path__ + "static/media/1143.0c06d1ed.png";